// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf } from "@altostra/type-validations";
import { string } from "@altostra/type-validations/lib/primitives";

const emailClientMetadata = objectOf({
  id: string,
  display_name: string,
  os: string,
  category: string,
  thumbnail: string,
  fullsize: string,
  status: string,
  code_analysis: string,
});

export const isEngagementGetEmailClientMetadataResult = arrayOf(emailClientMetadata);
